import type { Params } from 'src/hooks/dfp';
import { CAN_USE_DOM } from 'src/constants/other';
import responsive from 'src/styles/responsive.module.scss';

export const EMPTY_BANNER_PARAMS: Params = { slotPath: '', slotSize: [0, 0] };

export function shouldServeAds(): boolean {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (new URLSearchParams(window.location.search).has('serveAds')) {
    return true;
  }

  if (process.env.ENV === 'local') {
    return false;
  }

  const { hostname } = window.location;

  return hostname !== 'localhost';
}

export function getBannerParams(): Params {
  if (!CAN_USE_DOM) {
    return EMPTY_BANNER_PARAMS;
  }

  const isMobile = window.matchMedia(responsive.interstitial).matches;

  return {
    containerId: isMobile ? 'div-gpt-ad-1787119551229-0' : '',
    slotPath: isMobile ? '/242748299/news_app/Political_match/MAAVARON' : '',
    slotSize: isMobile ? [320, 410] : [],
    targeting: isMobile ? undefined : ['FORMAT', ['FULLSCREEN']],
    closable: true,
  };
}
